<template src="./DoctorsRegistered.html"></template>

<script>
import mixins from "../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      doctors: [],
      specialties: [],
      doctorsTemp: [],
      popupAddDoctor: false,
      doctorsSearch: [],
      typedWord: "",
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      searchDoctors: "",
      selected: [],
      disabledConfirmButton: true,
      doctorId: null,
      doctorSelected: {},
      resendWelcomePopup: false,
      resendId: undefined,
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    currentx: function() {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getDoctors();
    },
    changePagination(){
      const vm = this;
      vm.getDoctors();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    activateDoctor(doctor) {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "admin/doctors/" +
            doctor.id +
            "/active",
          doctor,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$nextTick(() => {
                vm.removeFocus();
            });
            vm.$nextTick(() => {
                vm.getDoctors();
            });
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Atenção!",
            html:
              "Não foi possível ativar o profissional <b>" +
              doctor.name +
              "</b>. Contacte o administrador do sistema ",
            icon: "error"
          }).then(function() {
            vm.getDoctors();
          });
        });
    },

    disableDoctor(doctor) {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "admin/doctors/" +
            doctor.id +
            "/inactivate",
          doctor,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$nextTick(() => {
                vm.removeFocus();
            });
            vm.$nextTick(() => {
                vm.getDoctors();
            });
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Atenção!",
            html:
              "Não foi possível desativar o profissional <b>" +
              doctor.name +
              "</b>. Contacte o administrador do sistema ",
            icon: "error"
          }).then(function() {
            vm.getDoctors();
          });
        });
    },
    getDoctors() {
      const vm = this;
      vm.$vs.loading();
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/doctors?page=" + page + "&search="+ vm.searchDoctors + "&size=10&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.doctors = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            for (let d in vm.doctors) {
              vm.doctors[d].dateBr = vm.formatDateBr(vm.doctors[d].create_date);
              if(vm.testNullUndefinedEmpty(vm.doctors[d].crmState) || vm.testNullUndefinedEmpty(vm.doctors[d].crmNumber)){
                vm.doctors[d].crm = "Não informado"
              }
              else {
                vm.doctors[d].crm =
                vm.doctors[d].crmState.toUpperCase() +
                " " +
                vm.doctors[d].crmNumber;
              }

            }
            for (let d in vm.doctors) {
              if (vm.testNullUndefinedEmpty(vm.doctors[d].phone)) {
                vm.doctors[d].phoneFormat = "Não informado";
              } else if (vm.doctors[d].phone.length == 10) {
                vm.doctors[d].phoneFormat = vm.doctors[d].phone.replace(
                  /(\d{2})(\d{4})(\d{4})/,
                  "($1) $2-$3"
                );
              } else {
                if(vm.testNullUndefinedEmpty(vm.doctors[d].phone) == false)
                vm.doctors[d].phoneFormat = vm.doctors[d].phone.replace(
                  /(\d{2})(\d{5})(\d{4})/,
                  "($1) $2-$3"
                );
              }
            }
          }
        }).finally(() => {
          vm.$vs.loading.close();
        });
    },
    changeSearchDoctors(){
      const vm = this;
      vm.currentx = 0;
      vm.$vs.loading();
      vm.getDoctors();
    },
    resendWelcomeAlert(index) {
      const vm = this;

      vm.resendId = index.id;
      vm.resendWelcomePopup = true;
    },
    resendWelcome(){
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/send-email-doctor-create-password?doctorId=" + vm.resendId,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.resendWelcomePopup = false;
            vm.$swal({
              title: "Sucesso!",
              text:
                "Operação realizada com sucesso! O e-mail de boas-vindas foi enviado para o médico.",
              icon: "success"
            })
          }
        })
        .catch(function() {
          vm.resendWelcomePopup = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
            icon: "error"
          });
        });
    },
    removeFocus() {
      document.activeElement.blur()
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" src="./DoctorsRegistered.scss">
</style>
